import { setup, styled } from "goober";
import { createElement } from "react";
setup(createElement);
const BgImage = styled("div")(
  ({ url, url_set }) => `
      @media only screen and (-webkit-min-device-pixel-ratio: 1), only screen and (min-resolution: 1dppx) {
        background-image: url(${url_set[0]});
      }
      @media only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min-resolution: 2dppx) {
          background-image: url(${url_set[1]});
      }
  
      @media only screen and (-webkit-min-device-pixel-ratio: 3), only screen and (min-resolution: 3dppx) {
          background-image: url(${url_set[2]});
      }
      background-image: url(${url});
      background-image: image-set(url(${url_set[0]}) 1x, url(${url_set[1]}) 2x, url(${url_set[2]}) 3x);
    `
);
export {
  BgImage as default
};
//# sourceMappingURL=basic-bg-image.js.map
